class CardCartIcon {
  static instance = null;
  
  constructor() {
    if (CardCartIcon.instance) {
      return CardCartIcon.instance;
    }
    CardCartIcon.instance = this;
    this.setupEventListeners();
  }

  setupEventListeners() {
    if (this.eventListenerAdded) {
      console.log('Event listeners already added, skipping');
      return;
    }
    
    console.log('Setting up event listeners for cart buttons');
    
    document.addEventListener('click', (e) => {
      const cartIcon = e.target.closest('.card__cart-icon');
      console.log('Click detected, cartIcon:', cartIcon);
      if (cartIcon && !cartIcon.disabled) {
        console.log('Cart button clicked, productId:', cartIcon.dataset.productId);
        e.preventDefault();
        e.stopPropagation();
        this.handleAddToCart(cartIcon);
      }
    });
    
    this.eventListenerAdded = true;
    console.log('Event listeners setup complete');
  }

  async handleAddToCart(button) {
    const productId = button.dataset.productId;
    const quantity = parseInt(button.dataset.quantity) || 1;

    if (!productId) {
      console.error('No product ID found');
      return;
    }

    this.setButtonLoading(button, true);

    try {
      // Get cart drawer sections to render
      const cartDrawer = document.querySelector('cart-drawer');
      let sections = [];
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        try {
          const sectionsToRender = cartDrawer.getSectionsToRender();
          if (sectionsToRender && Array.isArray(sectionsToRender)) {
            sections = sectionsToRender.map((section) => section.id);
          }
        } catch (e) {
          console.error('Error getting sections to render:', e);
        }
      }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: parseInt(productId),
            quantity: quantity,
            form_type: 'collection',
            utf8: '✓'
          }],
          sections: sections
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.description || errorData.message || 'Failed to add to cart');
      }

      const responseData = await response.json();

      // Update cart drawer content
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        try {
          cartDrawer.renderContents(responseData);
        } catch (e) {
          console.error('Error rendering cart drawer contents:', e);
        }
      }

      // this.updateCartCount(responseData.item_count);

      this.openCartDrawer();

      this.setButtonLoading(button, false, true);

    } catch (error) {
      console.error('Error adding to cart:', error);
      // alert('Error adding to cart: ' + error.message);
      this.setButtonLoading(button, false, false);
    }
  }

  setButtonLoading(button, isLoading, success = false) {
    if (isLoading) {
      button.dataset.originalContent = button.innerHTML;
      button.disabled = true;
      button.innerHTML = `
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="animate-spin">
          <circle cx="12" cy="12" r="10" stroke-opacity="0.25"/>
          <path d="M12 2a10 10 0 0 1 10 10" stroke-opacity="0.75">
            <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="1s" repeatCount="indefinite"/>
          </path>
        </svg>
      `;
    } else {
      button.disabled = !success;
      button.innerHTML = button.dataset.originalContent || `
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M6 6h15l-1.5 9h-12z"/>
          <circle cx="9" cy="20" r="1"/>
          <circle cx="18" cy="20" r="1"/>
          <path d="M6 6L4 2H1"/>
        </svg>
      `;
    }
  }

  updateCartCount(cartCount) {
    const cartCountBubbles = document.querySelectorAll('.cart-count-bubble');
    cartCountBubbles.forEach(bubble => {
      const countSpan = bubble.querySelector('span[aria-hidden="true"]');
      if (countSpan) {
        countSpan.textContent = cartCount;
      }
    });

    if (cartCount > 0 && cartCountBubbles.length === 0) {
      const cartLinks = document.querySelectorAll('a[href="/cart"]');
      cartLinks.forEach(cartLink => {
        const existingBubble = cartLink.querySelector('.cart-count-bubble');
        if (!existingBubble) {
          const bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          const countSpan = document.createElement('span');
          countSpan.setAttribute('aria-hidden', 'true');
          countSpan.textContent = cartCount;
          bubble.appendChild(countSpan);

          const visuallyHiddenSpan = document.createElement('span');
          visuallyHiddenSpan.className = 'visually-hidden';
          visuallyHiddenSpan.textContent = cartCount + ' items in cart';
          bubble.appendChild(visuallyHiddenSpan);

          cartLink.appendChild(bubble);
        }
      });
    }

    if (cartCount === 0) {
      const cartLinks = document.querySelectorAll('a[href="/cart"]');
      cartLinks.forEach(cartLink => {
        const bubble = cartLink.querySelector('.cart-count-bubble');
        if (bubble) {
          bubble.remove();
        }
      });
    }

    const otherCartCountElements = document.querySelectorAll('[data-cart-count], .cart-count, .cart-item-count');
    otherCartCountElements.forEach(element => {
      element.textContent = cartCount;
    });
  }

  openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.open();
    }
  }
}

new CardCartIcon();